<template>
  <div v-if="searchTerm.geogrids.length > 1" class="geogrid-slider">
    <div class="geogrid-slider-list">
      <button class="btn btn-link" @click="scrollGGList(-1)">
        <i class="far fa-chevron-left" />
      </button>
      <div class="position-relative scroll hor" ref="geogridListWrap">
        <div v-for="gg in searchTerm.geogrids"
          :key="gg.obfuscatedId"
          :class="['geogrid-slider-item', { active: geogrid.obfuscatedId === gg.obfuscatedId }]"
          :data-geogrid-id="gg.obfuscatedId"
          @click="updateGeogrid(gg)">
          <GeogridPreview :ranks="gg.ranks" />
          <span class="datetime">{{ gg.createdAtFormatted }}</span>
        </div>
      </div>
      <button class="btn btn-link" @click="scrollGGList(1)">
        <i class="far fa-chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import GeogridPreview from '../../components/geogrid_preview'

export default {
  name: 'Slider',
  components: { GeogridPreview },
  props: {
    isScheduledShow: { type: Boolean, default: false }
  },
  computed: {
    ...mapState(['geogrid', 'searchTerm'])
  },
  methods: {
    ...mapActions(['showGeogrid']),
    scrollGGList(k) {
      const { geogridListWrap } = this.$refs

      if (!geogridListWrap) return

      const childWidth = geogridListWrap.firstElementChild?.offsetWidth || 0
      const visibleChildCount = Math.floor(geogridListWrap.offsetWidth / childWidth)

      geogridListWrap.scrollTo({
        left: geogridListWrap.scrollLeft + childWidth * visibleChildCount * k,
        behavior: 'smooth'
      })
    },
    scrollToGeogrid() {
      const { geogridListWrap } = this.$refs

      if (!geogridListWrap) return

      const selectedElement = geogridListWrap.querySelector(`[data-geogrid-id="${this.geogrid.obfuscatedId}"]`)
      if (selectedElement) {
        geogridListWrap.scrollTo({
          left: selectedElement.offsetLeft
        })
      }
      this.updatedFromSlider = false
    },
    updateGeogrid(gg) {
      this.updatedFromSlider = true
      this.showGeogrid({ geogrid: gg })
    }
  },
  watch: {
    'searchTerm.geogrids': {
      deep: true,
      handler() {
        if (this.searchTerm.geogrids.length > 1) {
          this.$nextTick(() => {
            this.scrollToGeogrid()
          })
        }
      }
    },
    isScheduledShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.scrollToGeogrid()
        })
      }
    },
    geogrid: {
      deep: true,
      handler(val) {
        if (val && !this.updatedFromSlider) {
          this.$nextTick(() => {
            this.scrollToGeogrid()
          })
        }
      }
    }
  }
}
</script>
